const mapSVG = document.querySelector(".map-internationalization svg");
const countryButtons = document.querySelectorAll(
  ".internationalization__country--button"
);
const paths = mapSVG.querySelectorAll("path");
const countrySections = document.querySelectorAll(
  ".internationalization-response__wrapper"
);

const closeButtons = document.querySelectorAll(
  ".internationalization-response__close"
);

closeButtons.forEach((button) => {
  button.addEventListener("click", function (e) {
    e.preventDefault();

    const parentWrapper = this.closest(
      ".internationalization-response__wrapper"
    );
    const countryId = parentWrapper.dataset.country;

    parentWrapper.classList.remove("active");

    document
      .querySelectorAll(".internationalization__country--button")
      .forEach((btn) => {
        if (btn.dataset.country === countryId) {
          btn.classList.remove("active");
        }
      });

    document
      .querySelectorAll(".map-internationalization svg path")
      .forEach((path) => {
        if (path.id === countryId) {
          path.classList.remove("active");
        }
      });

    window.location.hash = "#top";
  });
});
const countryIds = Array.from(countryButtons).map(
  (button) => button.dataset.country
);
paths.forEach((path) => {
  if (countryIds.includes(path.id)) {
    path.classList.add("selectable");
  }
});

function activateCountry(countryId) {
  countryButtons.forEach((button) => {
    button.classList.toggle("active", button.dataset.country === countryId);
  });

  paths.forEach((path) => {
    path.classList.toggle("active", path.id === countryId);
  });

  countrySections.forEach((section) => {
    section.classList.toggle("active", section.dataset.country === countryId);
  });
}

countryButtons.forEach((button) => {
  button.addEventListener("click", function () {
    activateCountry(this.dataset.country);
    window.location.hash = "#convenios";
  });
});

paths.forEach((path) => {
  path.addEventListener("click", function () {
    if (this.classList.contains("selectable")) {
      activateCountry(this.id);
      window.location.hash = "#convenios";
    }
  });
});
